<template>
  <div id="multistepform">
    <FormIndicator v-model="step"></FormIndicator>
    <div id="step_1" class="step step_1" v-if="step == 1">
      <div class="number_colour">
        <h2 class="heading">1</h2>
      </div>
      <h2 class="bold_uppercase home">What kind of café are you?</h2>
      <p class="paragraph_header black">Select one of the below to move on to the next section.</p>
      <div class="icon_row">
        <div :class="selectedClass(0, 1)" @click="select(0, 1)">
          <div class="coloured_div"><img src="/app/uploads/2020/06/New-Location-Icon-2.svg" width="60" height="60" alt="" class="product_icon"></div>
          <a class="product_link">We're just getting started</a>
          <p class="paragraph_home icons_sec"></p>
        </div>
        <div :class="selectedClass(0, 2)" @click="select(0, 2)">
          <div class="coloured_div"><img src="/app/uploads/2020/06/Established-Business.svg" width="60" height="60" alt="" class="product_icon"></div>
          <a class="product_link">We're an established café</a>
          <p class="paragraph_home icons_sec"></p>
        </div>
        <div :class="selectedClass(0, 3)" @click="select(0, 3)">
          <div class="coloured_div"><img src="/app/uploads/2020/06/Chain-Cafe.svg" width="60" height="60" alt="" class="product_icon"></div>
          <a class="product_link">We're part of a chain</a>
          <p class="paragraph_home icons_sec"></p>
        </div>
      </div>
      <div class="product_icons_cta"><button :disabled="selection[0] == 0" @click.prevent="step++" class="main_button business w-button">go to next step</button></div>
    </div>

    <div id="step_2" class="step step_2"  v-if="step == 2">
      <div class="number_colour">
        <h2 class="heading">2</h2>
      </div>
      <h2 class="bold_uppercase home">How many Coffees do you serve each day?</h2>
      <p class="paragraph_header black">If you're a start-up, let us know your estimate.</p>
      <div class="icon_row">
        <div :class="selectedClass(1, 1)" @click="select(1, 1)">
          <div class="coloured_div"><img src="/app/uploads/2020/06/Few-Cups_Quiet-Cafe1.svg" width="60" height="60" alt="" class="product_icon"></div>
          <a class="product_link">1-50</a>
          <p class="paragraph_home icons_sec"></p>
        </div>
        <div :class="selectedClass(1, 2)" @click="select(1, 2)">
          <div class="coloured_div"><img src="/app/uploads/2020/06/Mid-Size-Cafe.svg" width="60" height="60" alt="" class="product_icon"></div><a class="product_link">50-120</a>
          <p class="paragraph_home icons_sec"></p>
        </div>
        <div :class="selectedClass(1, 3)" @click="select(1, 3)">
          <div class="coloured_div"><img src="/app/uploads/2020/06/Larger-Cafe.svg" width="60" height="60" alt="" class="product_icon"></div><a class="product_link">120+</a>
          <p class="paragraph_home icons_sec"></p>
        </div>
      </div>
      <div class="product_icons_cta"><button :disabled="selection[1] == 0" @click.prevent="step++" class="main_button business w-button">go to next step</button></div>
    </div>
    <div id="step_3" class="step step_3"  v-if="step == 3">
      <div class="number_colour">
        <h2 class="heading">3</h2>
      </div>
      <h2 class="bold_uppercase home">Are you interested in café supplies too?</h2>
      <p class="paragraph_header black">Supplies like tea, hot chocolate, snacks, barista equipment etc.</p>
      <div class="icon_row">
        <div :class="selectedClass(2, 1)" @click="select(2, 1)"> 
          <div class="coloured_div"><img src="/app/uploads/2020/06/More-than-Coffee-Snacks.svg" width="60" height="60" alt="" class="product_icon"></div>
          <a class="product_link">Sure, sounds interesting!</a>
          <p class="paragraph_home icons_sec"></p>
        </div>
        <div :class="selectedClass(2, 2)" @click="select(2, 2)">
          <div class="coloured_div"><img src="/app/uploads/2020/06/Coffee-Beans-2.svg" width="60" height="60" alt="" class="product_icon"></div>
          <a class="product_link">Just coffee and/or machines, thanks</a>
          <p class="paragraph_home icons_sec"></p>
        </div>
      </div>
      <div class="product_icons_cta"><button :disabled="selection[2] == 0" @click.prevent="finish()" class="main_button business w-button">Finish</button></div>
      <div class="zigzag_divider _180"></div>
    </div>

  </div> 
</template>


<script>
  import axios from 'axios';
  import FormIndicator from './SubComponents/FormIndicator.vue';
  export default {
    components: {
      FormIndicator
    },
    data: function () {
      return {
        message: "Hello",
        step: 1,
        selection: [0,0,0]
      };
    },
    methods: {
      async sample() {
        const { data } = await axios.get(``);
      },
      selectedClass(index, value) {
        return 'icon_col filter ' + (this.selection[index] == value ? "selected" : "" );
      },
      select(index, value) {
        this.$set(this.selection, index, value);
      },
      finish() {

        let size = "";
        if(this.selection[0] == 1) {
          size = "We are start-up café";
        } else if (this.selection[0] == 2) {
          size = "We are an established café";
        } else if (this.selection[0] == 3) {
          size = "We are a café chain";
        }

        let quantity = "";
        if(this.selection[1] == 1) {
          quantity = "1-50";
        } else if (this.selection[1] == 2) {
          quantity = "50-120";
        } else if (this.selection[1] == 3) {
          quantity = "more than 120";
        }

        let products = "";
        if(this.selection[2] == 1) {
          products = "We are interested in coffee and café supplies.";
        } else if (this.selection[2] == 2) {
          products = "We are just interested in coffee";
        } 

        let text = `${size}, and we serve ${quantity} coffees per day. ${products}\r\n`;

        window.localStorage.formtext = text; 
        window.location = "/contact-us";
      }
    },
    computed: {
    },
    async mounted() {
      
    }
  }

</script>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/MultiStepForm.vue